<template>
  <section>
    <v-container fluid v-show="isOpenMain">
      <!-- Breadcrumb and graphics -->
      <v-row justify="end" style="min-height: 64px">
        <v-col cols="auto">
          <v-switch
            v-model="isOpenGraph"
            inset
            class="mt-0"
            label="Ver gráficas"
            hide-details
          ></v-switch>
        </v-col>
      </v-row>

      <!-- Search field -->
      <v-row class="justify-end align-center" style="min-height:68px">
        <v-col cols="auto">
          <v-btn
            @click="isActiveRecycle = true"
            v-bind="attrs"
            v-on="on"
            small
            rounded
            fab
          >
            <v-icon>
              mdi-recycle-variant
            </v-icon>
          </v-btn>
        </v-col>

        <v-col cols="auto">
          <v-btn
            @click="isActiveDownload = true"
            color="success"
            v-bind="attrs"
            v-on="on"
            small
            rounded
            fab
          >
            <v-icon>
              mdi-download
            </v-icon>
          </v-btn>
        </v-col>

        <v-col cols="auto">
          <v-text-field
            filled
            rounded
            dense
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
          <!-- @click="isOpenSearch = true" -->
        </v-col>
      </v-row>

      <!-- Card -->
      <v-card class="shadow-1 mt-5 mt-md-10">
        <!-- Table -->
        <v-data-table
          v-if="!isOpenGraph"
          :search="search"
          :headers="headers"
          :items="typificationList"
          item-key="id"
          :loading="isLoading"
          :options.sync="options"
          :server-items-length="totalItems"
          no-data-text="No hay registros que mostrar"
          :footer-props="{
            'items-per-page-options': [15, 30, 50, 100],
          }"
        >
          <template v-slot:[`item.action`]="{ item }">
            <!-- <template v-if="item.register_typing_count > 0"> -->
            <v-hover v-slot:default="{ hover }">
              <v-btn
                text
                icon
                :color="hover ? 'accent' : 'blue-grey'"
                @click.stop="openQueueDetails(item)"
              >
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </v-hover>
            <!-- </template> -->
          </template>
        </v-data-table>

        <!-- Gráficas -->
        <v-container v-else fluid>
          <v-row align="center" justify="center">
            <v-col cols="12" md="5" v-if="isOpenGraph">
              <v-card outlined>
                <v-card-text>
                  <apexchart
                    ref="chart5"
                    type="donut"
                    :options="optionsDonut"
                    :series="donutSeries"
                  ></apexchart>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col v-else-if="!isOpenGraph" cols="12" md="5">
              <v-skeleton-loader
                transition="scale-transition"
                class="mx-auto"
                type="card"
              >
              </v-skeleton-loader>
            </v-col>

            <v-col v-if="isOpenGraph" cols="12" md="6">
              <v-card outlined>
                <v-card-text>
                  <apexchart
                    ref="chart7"
                    type="bar"
                    :options="optionsBar"
                    :series="barSeries"
                  ></apexchart>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col v-else cols="12" md="6">
              <v-skeleton-loader
                transition="scale-transition"
                class="mx-auto"
                type="card"
              >
              </v-skeleton-loader>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-container>
    <queue-details
      v-if="isOpenQueue"
      :title="queueSelected.name"
      :idQueue="queueSelected.id"
      @close:queue="closeQueueDetails"
    ></queue-details>

    <!-- <search-dialog
      :isActive="isOpenSearch"
      @dialog:close="closeSearch"
      type="queueList"
    ></search-dialog> -->

    <download-dialog
      v-if="isActiveDownload"
      :active="isActiveDownload"
      @dialog:close="isActiveDownload = false"
    ></download-dialog>

    <recycle-dialog
      v-if="isActiveRecycle"
      :active="isActiveRecycle"
      @dialog:close="isActiveRecycle = false"
    ></recycle-dialog>
  </section>
</template>

<script>
import DepartmentDetails from "../../components/Directory/DepartmentDetails.vue";
import QueueDetails from "../../components/TypificationReport/QueueDetails.vue";
import { PbxHttpClient } from "@/services/httpclient";
// import SearchDialog from "../../components/TypificationReport/SearchDialog.vue";
import getSearchString from "@/components/TypificationReport/getSearchString";
import DownloadDialog from "@/views/app/TypificationReport/DownloadDialog.vue";
import RecycleDialog from "@/views/app/TypificationReport/RecycleDialog.vue";

export default {
  name: "typificationList",

  components: {
    DepartmentDetails,
    QueueDetails,
    // SearchDialog,
    DownloadDialog,
    RecycleDialog,
  },

  data() {
    return {
      isLoading: false,
      isOpenMain: true,
      isOpenQueue: false,
      isOpenGraph: false,
      isOpenSearch: false,
      isActiveDownload: false,
      isActiveRecycle: false,
      search: "",
      // searchParams: {},
      // For pagination
      options: {
        page: 1,
        itemsPerPage: 15,
      },
      totalItems: 0,
      // End for pagination
      title: "Directorio",
      typificationList: [],
      queueSelected: {},
      headers: [
        {
          text: "Nombre",
          align: "left",
          value: "name",
          class: "primary--text",
          width: "40%",
        },
        {
          text: "Numero",
          value: "number",
          class: "primary--text",
          width: "25%",
        },
        {
          text: "Cantidad",
          value: "register_typing_count",
          class: "primary--text",
          width: "20%",
        },
        {
          text: "Acciones",
          value: "action",
          class: "primary--text",
          width: "15%",
          align: "left",
          sortable: false,
        },
      ],
      optionsDonut: {
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: "100%",
              },
            },
          },
        ],
        width: "100%",
        legend: {
          position: "bottom",
        },
        dataLabels: { enabled: false },
        labels: [],
      },
      optionsBar: {
        xaxis: {
          categories: [],
        },
        fill: {
          colors: ["#6D71F9"],
        },
      },
      donutSeries: [],
      barSeries: [{ name: "Cantidad", data: [] }],
    };
  },

  created() {
    this.getGraphics();
  },

  watch: {
    options: {
      handler() {
        this.getTypifications();
      },
      deep: true,
    },
    search() {
      this.getTypifications();
    },
  },

  methods: {
    async getTypifications() {
      const { page } = this.options || 1;
      const itemPerPage = this.options.itemsPerPage || 15;
      this.isLoading = true;
      try {
        const { data } = await PbxHttpClient.get("/typing/report/register", {
          params: { name: this.search, page, itemPerPage },
        });
        this.typificationList = data.data;
        this.totalItems = data.total;
      } catch (err) {
        this.$snotify.error("No se pudo obtener los datos.", "¡Error!");
      }
      this.isLoading = false;
    },
    async getGraphics() {
      try {
        const { data } = await PbxHttpClient.get(
          "/typing/report/graphi/register"
        );
        this.optionsDonut.labels = data.map((el) => el.name);
        this.optionsBar.xaxis.categories = data.map((el) => el.name);
        this.donutSeries = data.map((el) => el.register_typing_count);
        this.barSeries = [{ name: "Cantidad", data: this.donutSeries }];
      } catch (err) {
        this.$snotify.error("No se pudo obtener los datos.", "¡Error!");
      }
    },
    openQueueDetails(item) {
      this.queueSelected = item;
      this.isOpenMain = false;
      this.isOpenQueue = true;
    },
    closeQueueDetails() {
      this.isOpenMain = true;
      this.isOpenQueue = false;
      this.queueSelected = {};
    },
    // closeSearch(params) {
    //   this.searchParams = params;
    //   this.search =
    //     Object.keys(params).length === 0 ? "" : getSearchString(params);
    //   this.isOpenSearch = false;
    // },
  },
};
</script>

<style></style>
